import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';
import {
  SidebarHeading,
  PageHeader,
  ColoredHeading,
  Section,
  DangerousWrapper
} from '@budget-monorepo/shared-ui';
import kebabCase from 'lodash.kebabcase';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-closing-bracket-location */
const OutsideSectionPage = (props) => {
  const { data } = props;
  const { content, site } = data;
  const { outsideSections, budgetSection, parent } = content;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = parent;
  const createOutsideSectionSlug = (number, title) => kebabCase(`${number} ${title}`);

  const layoutProps = {
    activeIndex: 4,
    above: () => <PageHeader title="All Outside Sections" category={budgetSection} />,
    pageTitle: 'All Outside Sections',
    breadcrumbprops: [
      { href: 'outside-section', text: 'Outside Section' }
    ],
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // metadata for the page
  const metaTitle = `${budgetSection}: ${content.title}`;
  const metaDescription = `Details and summeries of all outside sections: ${budgetSection}`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {
          outsideSections.map((section, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Section key={`section${index}`}>
              <Link to={`/outside-section/${createOutsideSectionSlug(section.budgetSection, section.title)}`}>
                <ColoredHeading level={2} text={`${section.budgetSection}: ${section.title}`} />
              </Link>
              <Section>
                <DangerousWrapper rawHtml={section.content} />
              </Section>
              {section.summary && (
              <Section>
                <SidebarHeading title="Summary" />
                <DangerousWrapper rawHtml={section.summary} />
              </Section>
              )}
            </Section>
          ))
        }
      </Layout>
    </Fragment>
  );
};

OutsideSectionPage.propTypes = {
  data: PropTypes.object
};

export default OutsideSectionPage;

export const query = graphql`
  query {
    site {
      ...SiteMetadata
    }
    # Fetch the url of the pdf file of the outside sections to create an in page download link.
    # If the file name changes, the query here (eq: "fy2020h1_tab3.pdf") will need to be updated.
    download: file(base: { eq: "fy2020h1_tab3.pdf" }) {
      publicURL
    }
    # Fetch the title and budget section of every outside section listed in the outside-section.json
    content: pagesJson(fields: { slug: { eq: "/outside-section/" } }) {
      title
      budgetSection
      outsideSections {
        title
        budgetSection
        # summary
        content
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
